// extracted by mini-css-extract-plugin
export default {"products":"giveaway-landing-body__products___o1WRB","catalog":"giveaway-landing-body__catalog___G5Tod"};